import { ReactElement, useRef } from "react";

import { rootClass } from "chameleon/lib/components/radio-button/radio-button.css";
import { childrenClass } from "chameleon/lib/components/radio-tile/radio-tile.css";

import {
  borderClass,
  containerClass,
  radioButtonMessageWrapper,
} from "./tile.css";

export interface TileProps {
  /**
   * Optionally add children React components to be rendered inside the box, below the radio button
   */
  children?: JSX.Element | null;
  /**
   * ID used for accessibility
   */
  id: string;
  /**
   * Title component
   */
  title?: ReactElement;
}

export const Tile = ({ id, title, children }: TileProps) => {
  const childrenRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className={`${containerClass} ${borderClass}`}>
      <div className={`${radioButtonMessageWrapper}`}>
        <div
          data-testid={id}
          id={id}
          aria-label={`${id}-tile`}
          className={`${rootClass}`}
        >
          {title}
        </div>
      </div>
      {children ? (
        <div
          id={`${id}-children`}
          ref={childrenRef}
          className={`${childrenClass}`}
        >
          {children}
        </div>
      ) : null}
    </div>
  );
};
